// extracted by mini-css-extract-plugin
export default {"info":"Info_info__laNej","bg-info":"Info_bg-info__dIggw","overlay":"Info_overlay__BVE-8","info-title":"Info_info-title__AbLfv"};